import { Injectable } from '@angular/core';

export interface RangeOfDate {
  start: Date;
  end: Date;
}

export type PresetPeriod = 'Month' | 'Today' | 'Week' | 'Quarter' | 'Year';

@Injectable({
  providedIn: 'root',
})
export class DatePickerService {
  readonly DEFAULT_DATE_PERIOD = 'Month';
  selectedPeriod: PresetPeriod | 'Custom' = 'Month';

  setDefaultDate(): RangeOfDate {
    this.selectedPeriod = this.DEFAULT_DATE_PERIOD;

    const end = new Date();
    const start = new Date();
    start.setMonth(start.getMonth() - 1);

    return { start, end };
  }

  presetPeriod(preset: PresetPeriod): RangeOfDate {
    this.selectedPeriod = preset;

    const end = new Date();
    const start = new Date();

    switch (preset) {
      case 'Today':
        break;
      case 'Week':
        start.setDate(start.getDate() - 7);
        break;
      case 'Month':
        start.setMonth(start.getMonth() - 1);
        break;
      case 'Quarter':
        start.setMonth(start.getMonth() - 3);
        break;
      case 'Year':
        start.setFullYear(start.getFullYear() - 1);
        break;
      default:
        return { start, end };
    }

    return { start, end };
  }

  dateRangeSelected(range: RangeOfDate): RangeOfDate {
    this.selectedPeriod = 'Custom';
    return { start: range.start, end: range.end };
  }
}
